/* eslint-disable no-console */
import { useState, useEffect } from "react";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import { ToastContainer, toast } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import CardCount from "../../components/CardCount/CardCount";
import PageLoader from "../../components/PageLoader/pageloader";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Menu,
  MenuItem,
  // Select,
  // FormControl,
  // InputLabel,
  Tabs,
  Tab,
  Box,
  Drawer
} from "@mui/material";
import Badge from "../../components/Badge/Badge";
import MailIcon from "@mui/icons-material/Mail";
import VerifiedIcon from "@mui/icons-material/VerifiedUser";
import UnverifiedIcon from "@mui/icons-material/RemoveModerator";
import { Icon } from "@iconify/react";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import useStyles from "./styles";
import Button from "../../components/Button/Button";
import { httprequest } from "../../data/api";

const USER_ENDPOINT = "/admin/v1/get-all-users";

const AllEmployees = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [allUserData, setAllUserData] = useState([]);
  const [analyticData, setAnalyticData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  // const [dateRange, setDateRange] = useState("2months");
  // const [datePicker, setDatePicker] = useState("12nov-28nov");
  // const [school, setSchool] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editedEmail, setEditedEmail] = useState("");
  const [pageLoading, setPageLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const openMenu = Boolean(anchorEl);
  const classes = useStyles();
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [openInvalidModal, setOpenInvalidModal] = useState(false);
  const handleOpenVerify = () => setOpenVerifyModal(true);
  const handleCloseVerify = () => setOpenVerifyModal(false);
  const handleOpenInvalid = () => setOpenInvalidModal(true);
  const handleCloseInvalid = () => setOpenInvalidModal(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const getEmployeeData = () => {
    setPageLoading(true);
    httprequest
      .get(USER_ENDPOINT)
      .then((res) => {
        const userData = res?.data?.data || [];
        setAllUserData(userData);
        setSearchResult(userData);

        const analytics = {
          core: {
            all_mails: userData?.length,
            total_verified: userData?.filter((user) => user.email_valid).length,
            total_unverified: userData?.filter((user) => !user.email_valid)
              .length
          }
        };
        setAnalyticData(analytics);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error fetching users");
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedRow(null);
    setEditedEmail("");
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const updateEmailValidation = (userId, emailValid) => {
    setActionLoading(true);
    httprequest
      .patch(`/admin/v1/${userId}/update-user`, {
        email_valid: emailValid.toString()
      })
      .then((res) => {
        toast.success(
          res?.data?.message ||
            `Email ${
              emailValid ? "verified" : "marked as invalid"
            } successfully!`
        );
        getEmployeeData();
        closeDrawer();
        if (emailValid) {
          handleCloseVerify();
        } else {
          handleCloseInvalid();
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Error updating email validation status"
        );
      })
      .finally(() => {
        setActionLoading(false);
      });
  };

  const updateUserEmail = (userId, newEmail) => {
    setActionLoading(true);
    httprequest
      .patch(`/admin/v1/${userId}/update-user`, {
        email: newEmail
      })
      .then((res) => {
        getEmployeeData();
        closeDrawer();
        toast.success(res?.data?.message || "Email updated successfully!");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error updating email");
      })
      .finally(() => {
        setActionLoading(false);
      });
  };

  const confirmVerification = () => {
    if (!selectedRow) return;
    updateEmailValidation(selectedRow.id, true);
  };

  const confirmInvalid = () => {
    if (!selectedRow) return;
    updateEmailValidation(selectedRow.id, false);
  };

  const handleUpdateEmail = () => {
    if (!selectedRow || !editedEmail.trim()) {
      toast.error("Please enter a valid email address");

      return;
    }

    if (editedEmail === selectedRow.email) {
      toast.info("Email address is the same as current email");

      return;
    }

    updateUserEmail(selectedRow.id, editedEmail.trim());
  };

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
    setEditedEmail(row.email);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    handleMenuClose();
    if (action === "View Details") {
      setIsDrawerOpen(true);
    } else {
      console.log(`Performing ${action} on`, selectedRow);
      setSelectedRow(null);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    const statusMap = ["All", "Verified", "Unverified"];
    const status = statusMap[newValue];

    if (status === "All") {
      setSearchResult(allUserData);
    } else if (status === "Verified") {
      const filtered = allUserData.filter((item) => item.email_valid === true);
      setSearchResult(filtered);
    } else if (status === "Unverified") {
      const filtered = allUserData.filter((item) => item.email_valid === false);
      setSearchResult(filtered);
    }
  };

  // const handleDateRangeChange = (e) => setDateRange(e.target.value);
  // const handleDatePickerChange = (e) => setDatePicker(e.target.value);
  // const handleSchoolChange = (e) => setSchool(e.target.value);

  const getRole = (user) => {
    if (!user?.schools || user?.schools.length === 0) return "Employee";

    const roles = user?.schools.flatMap((school) => school.roles.map((role) => role.name)
    );

    return roles.join(", ") || "Employee";
  };

  const getSchoolName = (user) => {
    if (!user?.schools || user?.schools?.length === 0) return "N/A";

    return user?.schools.map((school) => school?.school_name).join(", ");
  };

  const getStatus = (user) => {
    return user?.email_valid ? "verified" : "unverified";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Never";
    const date = new Date(dateString);

    return date.toLocaleDateString();
  };

  const columns = [
    {
      name: "User",
      selector: (row) => `${row?.first_name} ${row?.last_name}`,
      sortable: true
    },
    {
      name: "Role",
      selector: (row) => getRole(row),
      sortable: true
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={getStatus(row)} />
    },
    {
      name: "",
      center: true,
      allowOverflow: true,
      button: true,
      cell: (row) => (
        <div className="table-action-container">
          <button
            onClick={(e) => handleMenuClick(e, row)}
            className="table-action-icon"
            disabled={pageLoading}
          >
            <Icon icon="ph:dots-three-bold" />
          </button>
        </div>
      )
    }
  ];

  const handleSearchTeacher = (e) => {
    const { value } = e.target;
    if (!value.trim()) {
      setSearchResult(allUserData);

      return;
    }
    const valArray = value.trim().split(" ");
    const result = allUserData?.filter((data) => valArray.every(
      (word) => data?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.last_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.email?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  const DrawerContent = () => (
    <div className={classes.drawerContainer}>
      <div className={classes.header}>
        <div className={classes.title}>Details</div>
        <div onClick={closeDrawer}>
          <Icon icon="line-md:close-circle-filled" width="24" height="24" />
        </div>
      </div>

      <div className={classes.card}>
        <div className={classes.cardTitle}>User Info</div>
        <div className={classes.flexColumn}>
          <div className={classes.gridRow}>
            <div className={classes.label}>Name:</div>
            <div className={classes.value}>
              {selectedRow?.first_name} {selectedRow?.last_name}
            </div>
          </div>
          <div className={classes.gridRow}>
            <div className={classes.label}>Role:</div>
            <div className={classes.value}>{getRole(selectedRow)}</div>
          </div>
          <div className={classes.gridRow}>
            <div className={classes.label}>School:</div>
            <div className={classes.value}>{getSchoolName(selectedRow)}</div>
          </div>
          <div className={classes.gridRow}>
            <div className={classes.label}>Last login:</div>
            <div className={classes.value}>
              {formatDate(selectedRow?.last_login)}
            </div>
          </div>
        </div>
      </div>

      <div className={classes.card}>
        <div className={classes.cardTitle}>Email Details</div>
        <div className={classes.flexColumn}>
          <div className={classes.gridRow}>
            <div className={classes.label}>Current email:</div>
            <div className={classes.value}>{selectedRow?.email}</div>
          </div>
          <div className={`${classes.gridRow} ${classes.flexCenter}`}>
            <div className={classes.label}>Verification status:</div>
            <Badge status={getStatus(selectedRow)} />
          </div>
          <div className={classes.gridRow}>
            <div className={classes.label}>Account Created:</div>
            <div className={classes.value}>
              {formatDate(selectedRow?.created_at)}
            </div>
          </div>
        </div>
      </div>

      <div className={classes.actionsCard}>
        <div className={classes.cardTitle}>Actions</div>
        <label className={classes.inputLabel}>Edit Email</label>
        <div className={classes.emailRow}>
          <div className={classes.emailInputWrapper}>
            <input
              type="email"
              value={editedEmail}
              onChange={(e) => setEditedEmail(e.target.value)}
              className={classes.emailInput}
              placeholder="Enter new email address"
              disabled={pageLoading || actionLoading}
            />
          </div>
          <div className={classes.saveButtonWrapper}>
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName={actionLoading ? "Updating..." : "Update"}
              className={classes.saveBtn}
              onClick={handleUpdateEmail}
              disabled={pageLoading || actionLoading}
            />
          </div>
        </div>

        <div className={classes.buttonGroup}>
          {!selectedRow?.email_valid && (
            <button
              className={classes.manualVerifyBtn}
              onClick={handleOpenVerify}
              disabled={selectedRow?.email_valid || pageLoading || actionLoading}
            >
              {actionLoading ? "Processing..." : "Manually Verify"}
            </button>
          )}
          {selectedRow?.email_valid && (
            <button
              className={classes.markInvalidBtn}
              onClick={handleOpenInvalid}
              disabled={!selectedRow?.email_valid || pageLoading || actionLoading}
            >
              {actionLoading ? "Processing..." : "Mark as Invalid"}
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <Layout>

      <PageTitle
        title="Email Validation"
        subtitle="Manage all Emails here."
      />

      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <CardCount
            title="All mails"
            count={analyticData?.core?.all_mails || 0}
            icon={<MailIcon />}
            isLoading={pageLoading}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <CardCount
            title="Total Verified"
            count={analyticData?.core?.total_verified || 0}
            icon={<VerifiedIcon />}
            isLoading={pageLoading}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <CardCount
            title="Total Unverified"
            count={analyticData?.core?.total_unverified || 0}
            icon={<UnverifiedIcon />}
            isLoading={pageLoading}
          />
        </Grid>
      </Grid>      {pageLoading && allUserData.length === 0 ? (
        <PageLoader />
      ) : (
        <>

          <div className="page_content">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                marginBottom: "16px",
                overflowX: "auto"
              }}
            >
              <Box
                sx={{
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  backgroundColor: "white"
                }}
              >
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{
                    minHeight: "32px",
                    "& .MuiTab-root": {
                      minHeight: "32px",
                      fontSize: "13px",
                      padding: "16px 16px"
                    }
                  }}
                >
                  <Tab label="All" disabled={pageLoading} />
                  <Tab label="Verified" disabled={pageLoading} />
                  <Tab label="Unverified" disabled={pageLoading} />
                </Tabs>
              </Box>
            </div>

            <Table
              data={searchResult.length > 0 ? searchResult : allUserData}
              columns={columns}
              subHeader={true}
              pagination
              selectableRows
              progressPending={pageLoading}
              subHeaderComponent={
                <div className="action_div">
                  <TableSearch
                    placeholder="Search here..."
                    searchTableFunc={handleSearchTeacher}
                    disabled={pageLoading}
                  />
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px"
                    }}
                  >
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <InputLabel>School</InputLabel>
                      <Select
                        value={school}
                        label="School"
                        onChange={handleSchoolChange}
                        sx={{ borderRadius: "6px", fontSize: "13px" }}
                        disabled={pageLoading}
                      >
                        <MenuItem value="">All Schools</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Date Range</InputLabel>
                      <Select
                        value={dateRange}
                        label="Date Range"
                        onChange={handleDateRangeChange}
                        sx={{ borderRadius: "6px", fontSize: "13px" }}
                        disabled={pageLoading}
                      >
                        <MenuItem value="1week">Last 1 week</MenuItem>
                        <MenuItem value="2months">Last 2 months</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 180 }}>
                      <InputLabel>Date Period</InputLabel>
                      <Select
                        value={datePicker}
                        label="Date Period"
                        onChange={handleDatePickerChange}
                        startAdornment={
                          <CalendarMonthIcon
                            style={{
                              fontSize: "16px",
                              color: "#9CA3AF",
                              marginRight: "8px"
                            }}
                          />
                        }
                        sx={{ borderRadius: "6px", fontSize: "13px" }}
                        disabled={pageLoading}
                      >
                        <MenuItem value="12nov-28nov">12 Nov - 28 Nov</MenuItem>
                      </Select>
                    </FormControl>
                  </div> */}
                </div>
              }
            />
          </div>

          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            PaperProps={{
              elevation: 3,
              style: {
                borderRadius: "12px",
                marginTop: "8px",
                minWidth: "180px"
              }
            }}
          >
            <MenuItem
              onClick={() => handleAction("View Details")}
              style={{ fontSize: "13px", padding: "10px 20px" }}
              disabled={pageLoading}
            >
              View Details
            </MenuItem>
          </Menu>

          <Drawer anchor="right" open={isDrawerOpen} onClose={closeDrawer}>
            <DrawerContent />
          </Drawer>

          <Dialog
            open={openVerifyModal}
            onClose={handleCloseVerify}
            PaperProps={{ className: classes.dialogPaper }}
          >
            <DialogTitle className={classes.dialogTitle}>
              Manual Verification
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <Typography className={classes.dialogContentText}>
                Are you sure you want to manually verify this email?
              </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <button
                className={classes.modalBtnCancel}
                onClick={handleCloseVerify}
                disabled={actionLoading}
              >
                Cancel
              </button>
              <button
                className={classes.modalBtnConfirm}
                onClick={confirmVerification}
                disabled={actionLoading}
              >
                {actionLoading ? "Processing..." : "Confirm Verification"}
              </button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openInvalidModal}
            onClose={handleCloseInvalid}
            PaperProps={{ className: classes.dialogPaper }}
          >
            <DialogTitle className={classes.dialogTitle}>
              Mark Email as Invalid?
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <Typography className={classes.dialogContentText}>
                User will lose access until a new email is added.
              </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <button
                className={classes.modalBtnCancel}
                onClick={handleCloseInvalid}
                disabled={actionLoading}
              >
                Cancel
              </button>
              <button
                className={classes.modalBtnInvalid}
                onClick={confirmInvalid}
                disabled={actionLoading}
              >
                {actionLoading ? "Processing..." : "Mark Invalid"}
              </button>
            </DialogActions>
          </Dialog>
          <ToastContainer />
        </>
      )}
    </Layout>
  );
};

export default AllEmployees;
